import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Trips } from '../api';

export type SortOptions = 'popularity' | 'next_trip' | 'price';
export const TIMES_OF_DAY = ['morning', 'day', 'evening', 'night'];

interface FilterState {
  nothingFound: boolean;
  trips: Trips;
  isLoadingTrips: boolean;
}

const initialState: FilterState = {
  nothingFound: false,
  trips: [],
  isLoadingTrips: true,
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setNothingFound: (state, action: PayloadAction<boolean>) => {
      state.nothingFound = action.payload;
    },
    setTrips: (state, action: PayloadAction<Trips>) => {
      state.trips = action.payload;
    },
    setLoadingTrips: (state, action: PayloadAction<boolean>) => {
      state.isLoadingTrips = action.payload;
    },
  },
});

export const { setNothingFound, setTrips, setLoadingTrips } = filterSlice.actions;

export default filterSlice.reducer;
